/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ShowDeletedAction/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCheckboxWithInputText from 'DesignSystem/TysiaCheckboxWithInputText/index'



/** @type {import('Simple/types.js').View} */
export default function ShowDeletedAction({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPlanTemplates/TxPlanTemplates/ShowDeletedAction",
  onChange
  
}) {
let selectedShowDeletedValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'show_deleted',
})
let selectedShowDeletedChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'show_deleted',
})
  return (<React.Fragment
>
<TysiaCheckboxWithInputText
  viewPath={`${viewPath}/TysiaCheckboxWithInputText`}
 marginTop={0.1}
 data="selected.show_deleted"
 value={selectedShowDeletedValueData}
 onChange={selectedShowDeletedChangeData}
 text="Show deleted"
/>
{children}
</React.Fragment>)
}